import React from 'react';
import Banner from "../base/Banner";
import Register from "./Register";
import getCustomerData, {getPosition} from "../../services/DataGetter";
import {setLanguage} from "../../enums/Languages";
import renderLoader from "../base/Loader";

export default class RegisterToPosition extends React.PureComponent
{
    constructor(props) {
        super(props);
        if (this.props.match.params['source']) {
            sessionStorage.setItem('source', this.props.match.params['source']);
            window.history.pushState(null, '', window.location.href.split(this.props.match.params['source'])[0]);
        }
        this.state = {
            step: 1,
            userName: sessionStorage.getItem('userName-' + this.props.match.params['customerName']),
            customerData: getCustomerData(this.props.match.params['customerName']),
            positionData: getPosition(this.props.match.params['positionId'], this.props.match.params['customerName']),
            loading: true
        };
        this.setLanguage(this.state['positionData']);
    }

    setLanguage = (positionData) => {
        positionData.then(positionData => {
            this.setState({language: setLanguage(this.props.match.params['lang'], positionData && positionData.success ? positionData.result.language : null), loading: false});
        });
    }

    setBannerData = (userName) => {
        this.setState({ userName: userName});
    };

    render(){
        if (this.state['loading']) {
            return renderLoader('d-block text-center display-1')
        }
        const { userName, language} = this.state;

        return (
            <>
                <Banner
                    customerName={this.props.match.params['customerName']}
                    language={language}
                    userName={userName}
                    positionId={this.props.match.params['positionId']}
                    customerData={this.state['customerData']}
                />
                <Register
                    customerName={this.props.match.params['customerName']}
                    positionData={this.state['positionData']}
                    customerData={this.state['customerData']}
                    positionId={this.props.match.params['positionId']}
                    language={language}
                    setBannerData={this.setBannerData}
                />
            </>
        );
    }

}
